export enum AccessLevel {
  Private = 'private',
  Shared = 'shared',
  Public = 'public', // TODO: Remove this field
}
